import * as React from 'react';

import { useTranslation } from 'next-i18next';
import { useRouter } from 'next/router';

import { GlossaryList } from '../../../components/common/GlossaryList';
import Layout from '../../../components/common/Layout';
import Strip from '../../../components/common/Strip';
import TextHeader from '../../../components/common/TextHeader';
import { MobileContextProvider } from '../../../helpers';
import { useItems } from '../../../hooks';
import { GLOSSARY } from '../../../queries';
import { withTranslation } from '../../../translation';

const GlossaryPage = ({ pageData }: any) => {
  const router = useRouter();
  const { t } = useTranslation('resources');
  const { SEO, textHeader, articles } = t('glossary', {
    returnObjects: true,
  }) as any;

  const { glossary } = pageData;

  const glossaryList = glossary
    .filter((entry: { translations: string | any[] }) => entry.translations.length)
    .sort((a: { translations: { title: any }[] }, b: { translations: { title: any }[] }) => {
      const aTitle = a.translations[0].title;
      const bTitle = b.translations[0].title;
      if (aTitle > bTitle) {
        return 1;
      }
      if (aTitle < bTitle) {
        return -1;
      }
      return 0;
    });

  return (
    <MobileContextProvider>
      <Layout SEO={SEO}>
        <Strip variant="white">
          <TextHeader variant="white" level={1} data={textHeader} />
        </Strip>
        <Strip variant="white">
          {glossaryList.length ? (
            <GlossaryList glossaryList={glossaryList} basePath={router.pathname} />
          ) : (
            <TextHeader level={1} data={articles.noEntries} />
          )}
        </Strip>
      </Layout>
    </MobileContextProvider>
  );
};

export default GlossaryPage;

export const getStaticProps = withTranslation(async (context) => {
  const articles = await useItems(GLOSSARY);

  return {
    props: {
      pageData: articles.items,
    },
  };
});
